import React from 'react'
import Projects from '../components/projects/components/Projects'
// import WatchlistHandler from '../components/projects/components/Handler'
import WatchlistHandler from '../components/projects/components/WatchlistHandler'
import { Typography, Container, Button } from '@mui/material'
import styles from './Dashboard.module.scss'
import FeedSearchModal from '../components/dashboardComponents/components/FeedSearchModal'
import { useGeneral } from '../context/general'
export default function Watchlist() {
    const { tickers } = useGeneral()
    return (
        <>
            <Container maxWidth="xl" className={styles['big-container']}>
                <section>
                    <section style={{display:'flex',justifyContent:'space-between'}}>
                        <Typography variant="h1">My Watchlist</Typography> 
                        {tickers?.length>0&&<FeedSearchModal Type='WatchlistHandler'>
                            <Button 
                                variant="contained" 
                                style={{color:'black'}}
                            > + Add Stocks To Watchlist</Button>
                        </FeedSearchModal>}
                    </section>
                    {/* Old Code --> showing watchlists directly from projects table based on the portfolio field */}
                    {/* <Projects variant="watchlist"/> */}

                    {/* New Code --> showing watchlists directly from watchlist table */}
                    <WatchlistHandler />
                </section>
            </Container>
                
        </>
    )
}
